import { Menu, MenuItem, MenuButton } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/zoom.css";
import { CardSettingsIcon } from "components/Icons";
import "./MenuDropdown.scss";

export default function MenuDropdown({ menuItems, setModalOpen }) {
	return (
		<Menu
			position="anchor"
			menuButton={
				<MenuButton>
					<CardSettingsIcon />
				</MenuButton>
			}
		>
			{menuItems.map((item) => (
				<MenuItem
					className="plt-body-sm szh-menu--dir-bottom"
					key={item.id}
					onClick={(e) => {
						if (item.action) {
							item.action();
						}
					}}
				>
					{item.label}
				</MenuItem>
			))}
		</Menu>
	);
}
